import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import Title from 'Root/App/Title'

import Chip from '../Chip'

library.add(faUser)

interface ShareMineProps {
  active?: boolean
  gratis?: boolean
  onClick?: () => void
}

const BoxIcon = () => (
  <span className="flex justify-center items-center bg-gray-200 w-10 h-10 min-w-10 rounded-lg">
    <FontAwesomeIcon className="text-lg text-gray-500" icon={['fas', 'user']} />
  </span>
)

const ShareMine = ({ active, gratis = false, onClick }: ShareMineProps) => {
  return (
    <Chip
      icon={<BoxIcon />}
      highlight
      highlightCustomClass="p-3 flex-col gap-y-3 sm:flex-1"
      active={active}
      onClick={onClick}
    >
      <span className="flex flex-col gap-y-1">
        <Title className="flex items-center gap-3" size="2XS">
          <Trans>Solo per me</Trans>
          {gratis && (
            <PreTitle className="p-1 bg-brand-accent3 text-white rounded">
              <Trans>GRATIS</Trans>
            </PreTitle>
          )}
        </Title>
        <Paragraph className="text-gray-500 sm:max-w-sm sm:w-auto">
          <Trans>
            I tuoi contenuti sono al sicuro nella tua bacheca, fino a che non lo
            deciderai, saranno accessibili solo a te.
          </Trans>
        </Paragraph>
      </span>
    </Chip>
  )
}

export default ShareMine
